module.exports = __webpack_public_path__ + "static/img/penny_pictgrid1_800x752.43d0403.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_pictgrid1_800x752.jpg
// module id = 9t5k
// module chunks = 0